export default "__VITE_ASSET__26cd00d4__"